import { HTTPInstance } from "@http/http-instance";
import { VenueData, VenueImage } from "./VenuesDataAPI.model";

export const getMobileAppData = async (
  restaurantId: string,
): Promise<VenueData> => {
  const { data } = await HTTPInstance.get<VenueData>(
    `/public/restaurants/${restaurantId}/mobile-app`,
  );
  return data;
};

/**
 * The venue's background photo, as uploaded in the RMS.
 *
 * Note the path: this lives on the restaurants controller, not under /public.
 * It answers anonymously today, which is what makes it usable here, but that
 * is not guaranteed — every caller must tolerate a failure and fall back.
 */
export const getRestaurantBackground = async (
  restaurantId: string,
): Promise<VenueImage> => {
  const { data } = await HTTPInstance.get<VenueImage>(
    `/restaurants/${restaurantId}/background`,
  );
  return data;
};

/** The venue's logo. Same caveat as the background above. */
export const getRestaurantLogo = async (
  restaurantId: string,
): Promise<VenueImage> => {
  const { data } = await HTTPInstance.get<VenueImage>(
    `/restaurants/${restaurantId}/logo`,
  );
  return data;
};
